export const Notifications = () => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.79167 3.1263H4.79167C3.87119 3.1263 3.125 3.87249 3.125 4.79297V15.2096C3.125 16.1301 3.87119 16.8763 4.79167 16.8763H15.2083C16.1288 16.8763 16.875 16.1301 16.875 15.2096V10.2096M16.9151 3.08622C17.9728 4.14389 17.9728 5.85871 16.9151 6.91638C15.8574 7.97405 14.1426 7.97405 13.0849 6.91638C12.0272 5.85871 12.0272 4.14389 13.0849 3.08622C14.1426 2.02855 15.8574 2.02855 16.9151 3.08622Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default Notifications
